import { getItem, removeItem, setItem } from "./localStorage.utils";

export const tokenName = "accessToken";

export function getToken() {
  return getItem(tokenName);
}

export function setToken(value) {
  return setItem(tokenName, value);
}

export function removeToken() {
  return removeItem(tokenName);
}
